export let PAYMENT_URL = '/';
const dev = {
  PAYMENT_URL: 'https://dev-payment.rockstreamer.com'
};
const stage = {
  PAYMENT_URL: 'https://stage-payment.rockstreamer.com'
};
const prod = {
  PAYMENT_URL: 'https://payment.rockstreamer.com'
};
if (process.env.REACT_APP_STAGE === 'production') {
  PAYMENT_URL = prod.PAYMENT_URL;
} 
else if (process.env.REACT_APP_STAGE === 'stage') {
  PAYMENT_URL = stage.PAYMENT_URL;
}
else {
  PAYMENT_URL = dev.PAYMENT_URL;
}
